import React from 'react';
import { NavLink } from 'react-router-dom';
import { EmptyFeed } from 'components';
import Icon from 'assets/icons';
import styles from './HomeFeedNoResults.module.scss';

export const HomeFeedNoResults = () => {
  return (
    <div className={styles.noFeedLayout}>
      <EmptyFeed message={'Connect your accounts to see document activity and collaborators.'} />
      <NavLink className={styles.moreAppsButton} to={`/manage-apps`}>
        <Icon.Plus />
        Add App
      </NavLink>
    </div>
  );
};
